module.exports = __webpack_public_path__ + "assets/kids/img/logo.28de38a3.png";